module.exports = __webpack_public_path__ + "img/dry-hairy-tree-07.8465f272.png";